import { createSvgIconComponent } from "../utils";
export var IconSVG = createSvgIconComponent();